import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IContentComponent } from 'src/app/interfaces/content-component.interface';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContentService } from 'src/app/services/content.service';
import { TitleService } from 'src/app/services/title.service';
@Component({
  selector: 'app-select-login',
  templateUrl: './select-login.component.html',
  styleUrls: ['./select-login.component.scss']
})
export class SelectLoginComponent implements OnInit, OnDestroy, IContentComponent {

  private componentDestroyed = new Subject();

  pageComponentName: string = 'Login';
  data!: Map<string, string>;

  complaintType!: number;
  attemptResolved!: number;
  attemptSettlement!: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contentService: ContentService,
    private authenticationService: AuthenticationService,
    private titleService: TitleService) {

    this.titleService.setTitle("Finansklagenemnda - Klageskjema");
    
    this.contentService.content
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (data: Map<string, string>) => {
          if (data !== undefined) {
            this.data = data;
          }
        }
      );

    this.contentService.loadContent('pageText', this.pageComponentName, ['text', 'label']);
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(params => {
        this.complaintType = +params['complaintType']; // (+) converts string 'id' to a number
        this.attemptResolved = +params['attemptResolved']; // (+) converts string 'id' to a number
        this.attemptSettlement = +params['attemptSettlement']; // (+) converts string 'id' to a number
      });
  }

  getLabelValue(label:string): string {
    let value: string = '';
    if (this.data) {
      value = this.data.get(label) ?? '';
    }
    return value;
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  navigate(url: string): void {
    this.router.navigateByUrl(url);
  }

  navigateBack(): void {
    var url: string = "/select/";
    url += this.complaintType;

    this.navigate(url);
  }

  login(): void {    
    var url = "/form/";
    url += this.complaintType.toString();
    url += "/" + this.attemptResolved;
    url += "/" + this.attemptSettlement;
   
    this.authenticationService.login(encodeURIComponent(url));

  }
}
